import { Grid, Typography } from "@mui/material";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ title, plugins, data, width, height }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        {title && (
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              marginBottom: "20px",
            }}
          >
            {title}
          </Typography>
        )}

        <Doughnut
          width={width}
          height={height}
          data={data}
          options={{
            responsive: true,
            aspectRatio: 1,
            plugins: {
              legend: {
                position: "bottom",

                labels: {
                  boxWidth: 9,
                  boxHeight: 9,
                  usePointStyle: true,
                },
              },

              ...plugins,
            },
          }}
          style={{ cursor: "pointer" }}
        />
      </Grid>
    </Grid>
  );
};

export default DoughnutChart;
